import React, { useEffect, useState } from 'react';
import S from './ListDam.module.css'
import D from '../images/cycle.svg'
import {  useSelector } from 'react-redux';
import Hoc from '../Components/HOCcattles/Hoc';
import useList from '../Components/CustomHooks/useList';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Box, Tab } from '@mui/material';
import History from '../Components/HOCcattles/History';


 function CyclePage() {
   const [value,setValue]=useState('1');
   const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className={S.AllAnimalssLICon}>
      <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} src={D}/>
        <h2>چرخه ها</h2>
        </div>
        <div style={{display:'flex', gap:'10px',alignItems:'center'}}>
        
        
        
        </div>
           
      </div>
      <TabContext value={value}>
  <Box  style={{direction:'rtl',marginBottom:'-40px',marginRight:'10px',padding:'0px 8px'}}>
    <TabList variant="scrollable" scrollButtons="auto" onChange={handleChange} aria-label="lab API tabs example">
      <Tab label="چرخه ها" value="1" />
      <Tab label="تاریخچه چرخه دام ها" value="2" />
      
    </TabList>
  </Box>
  <hr style={{marginTop:'37px'}}/>
  <TabPanel value='1'>
  <Hoc flag={'cycle'} id=''/>
  </TabPanel>
  <TabPanel value='2'>
  <History flag='all'/>
  </TabPanel>
  </TabContext>
      </div>
    </div>
  );
}


export default CyclePage